import { useHead, useSeoMeta } from '#imports'

export function useSEO () {
  const setPageSEO = (options = {}) => {
    const {
      title,
      description,
      keywords = [],
      image = '/images/logo-light.svg',
      url,
      type = 'website',
      publishedTime,
      modifiedTime,
      author = 'Vedware',
      siteName = 'Vedware',
    } = options

    // Set page title
    if (title) {
      useHead({
        title,
        titleTemplate: title.includes('Vedware') ? '%s' : '%s | Vedware',
      })
    }

    // Set meta tags
    useSeoMeta({
      title,
      description,
      ogTitle: title,
      ogDescription: description,
      ogImage: image,
      ogUrl: url,
      ogType: type,
      ogSiteName: siteName,
      twitterCard: 'summary_large_image',
      twitterTitle: title,
      twitterDescription: description,
      twitterImage: image,
      ...(keywords.length > 0 && { keywords: keywords.join(', ') }),
      ...(publishedTime && { articlePublishedTime: publishedTime }),
      ...(modifiedTime && { articleModifiedTime: modifiedTime }),
      ...(author && { articleAuthor: author }),
    })

    // Set structured data
    if (type === 'article' && publishedTime) {
      useHead({
        script: [
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Article',
              'headline': title,
              description,
              'image': image,
              'datePublished': publishedTime,
              'dateModified': modifiedTime || publishedTime,
              'author': {
                '@type': 'Organization',
                'name': author,
              },
              'publisher': {
                '@type': 'Organization',
                'name': siteName,
                'logo': {
                  '@type': 'ImageObject',
                  'url': 'https://vedware.com/images/logo.png',
                },
              },
            }),
          },
        ],
      })
    }
  }

  const setDefaultSEO = () => {
    setPageSEO({
      title: 'Vedware - Professional Web Development & Digital Solutions',
      description: 'Expert web development services, modern applications, and digital solutions. 20+ years of experience delivering high-quality projects for businesses worldwide.',
      keywords: ['web development', 'digital solutions', 'web applications', 'frontend development', 'backend development', 'full-stack development'],
      url: 'https://vedware.com',
    })
  }

  return {
    setPageSEO,
    setDefaultSEO,
  }
}
